import { ZoneTypeEnum } from "@/lib/enum/zone-type.enum";
import { Filter, IsFilterable } from "@/lib/filterable";
import { BoundingBox, IBoundingBox } from "@/models/bounding-box.entity";
import { MrfiktivZoneDtoGen, MrfiktivZoneViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";

@IsFilterable
export class ZoneBase implements MrfiktivZoneViewModelGen {
  name: string;

  boundingBoxInPercent: IBoundingBox;

  type: ZoneTypeEnum;

  constructor(data: MrfiktivZoneViewModelGen | IZone) {
    this.name = data?.name ?? "";
    this.boundingBoxInPercent = new BoundingBox(data.boundingBoxInPercent);
    this.type = (data?.type as ZoneTypeEnum) || ZoneTypeEnum.ZONE;
  }

  isHit(px: number, py: number): boolean {
    return this.boundingBoxInPercent.isHit(px, py);
  }

  getCenter(): { x: number; y: number } {
    return this.boundingBoxInPercent.getCenter();
  }

  get dto(): MrfiktivZoneDtoGen {
    return {
      name: this.name,
      type: this.type,
      boundingBoxInPercent: this.boundingBoxInPercent.dto
    };
  }
}

type IZone = ZoneBase;
const Zone = Filter.createForClass(ZoneBase);

export { IZone, Zone };
